import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { LocaleProvider } from '../context/localeContext';
import Layout from '../components/Layout';
import ResearchPublication from './ResearchPublication';
import SEO from '../components/SEO';

const ResearchPublicationTemplate = ({ data, pageContext, location }) => {

  return (
    <LocaleProvider locale={pageContext.locale}>
      <Layout>
        <ResearchPublication
          title={data.researchPublication.frontmatter.title}
          date={data.researchPublication.frontmatter.date}
          heroImage={data.researchPublication.frontmatter.image}
          downloads={data.researchPublication.frontmatter.downloads}
          takeaways={data.researchPublication.frontmatter.takeaways?.map(
            (item) => item.content
          )}
          content={data.researchPublication.htmlAst}
          tags={data.researchPublication.frontmatter.tags}
        />
      </Layout>
      <SEO
        title={data.researchPublication.frontmatter.title}
        image={data.researchPublication.frontmatter.image}
        type="research"
        path={location.pathname}
        date={data.researchPublication.frontmatter.date}
      />
    </LocaleProvider>
  );
};

ResearchPublicationTemplate.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default ResearchPublicationTemplate;

export const pageQuery = graphql`
  query ResearchPublicationByID($id: String!) {
    researchPublication: markdownRemark(id: { eq: $id }) {
      id
      htmlAst
      frontmatter {
        date
        image {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              placeholder: BLURRED
              layout: FULL_WIDTH
            )
          }
        }
        title
        takeaways {
          content
        }
        downloads {
          path
          label
        }
      }
    }
  }
`;
